import { render, staticRenderFns } from "./create-send-plan.vue?vue&type=template&id=2918ce10&scoped=true"
import script from "./create-send-plan.vue?vue&type=script&lang=js"
export * from "./create-send-plan.vue?vue&type=script&lang=js"
import style0 from "./create-send-plan.vue?vue&type=style&index=0&id=2918ce10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918ce10",
  null
  
)

export default component.exports